<template>
  <v-card>
    <v-card-title> Números do Whatsapp </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="pt-0">
          <span>Seleção de números do whatsapp - descrição completa</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <select-whatsapp-numbers-dialog :selected-whatsapp-numbers.sync="localSelectedWhatsappNumbers" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <v-chip-group show-arrows active-class="primary--text">
            <v-chip
              v-for="(whatsappNumber, index) in localSelectedWhatsappNumbers"
              :key="`selected-whatsapp-number-${index}`"
              small
              :ripple="false"
              close
              @click:close="removeWhatsappNumber(index)"
            >
              <b>{{ whatsappNumber.name }} - {{ phoneNumberFormat(whatsappNumber.number) }}</b>
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <p v-if="error" class="error--text">{{ error }}</p>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    SelectWhatsappNumbersDialog: () => import('@/modules/campanhas/whatsapp/views/components/SelectWhatsappNumbersDialog.vue'),
  },
  props: {
    selectedWhatsappNumbers: {
      type: Array,
    },
    error: {
      type: String,
    },
  },
  data: () => ({
    localSelectedWhatsappNumbers: [],
  }),
  watch: {
    localSelectedWhatsappNumbers: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.selectedWhatsappNumbers)) {
          this.$emit('update:selectedWhatsappNumbers', val)
        }
      },
    },
    selectedWhatsappNumbers: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.localSelectedWhatsappNumbers)) {
          this.localSelectedWhatsappNumbers = cloneDeep(val)
        }
      },
    },
  },
  mounted() {
    if (this.selectedWhatsappNumbers?.length) {
      this.localSelectedWhatsappNumbers = cloneDeep(this.selectedWhatsappNumbers)
    }
  },
  methods: {
    phoneNumberFormat,
    removeWhatsappNumber(index) {
      this.localSelectedWhatsappNumbers.splice(index, 1)
    },
  },
}
</script>
